import { AddOutlined, ArrowLeft, DeleteOutline } from "@mui/icons-material";
import { Loading } from "react-admin";
import {
  deleteAIChatSession,
  listAIChatSessions,
  listXPs,
} from "../../../services/aiChatService";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { use } from "react";
import { AIChatTypes } from "../../auth/util/CustomConstants";

export default function SidePanel(props) {
  const {
    styles,
    sidePanel,
    setSidePanel,
    profile,
    chats,
    setChats,
    setData,
    getChatData,
    setOpenConfigurationModal,
    setLatestQuestionIndex,
    setShowLoader,
    updateChartData,
    showToast,
    resetAll,
  } = props;
  const { id: aiChatId } = useParams() || null;
  const navigate = useNavigate();
  const [sidePanelLoader, setSidePanelLoader] = useState(false);

  const fetchAllXPData = async () => {
    try {
      setSidePanelLoader(true);
      let xpDetails = await listXPs();
      if (xpDetails?.status !== 200) {
        throw Error("Error in fetching XP details");
      }

      let chartData = xpDetails?.data?.data?.xpDetails;
      if (!chartData || chartData.length === 0) return null;

      return chartData;
    } catch (error) {
      console.error("Error in (fetchAllXPData): ", error);
      showToast("Can't get XP details", "error");
      return null;
    } finally {
      setSidePanelLoader(false);
    }
  };

  const fetchAllChats = async () => {
    try {
      setSidePanelLoader(true);

      const response = await listAIChatSessions(AIChatTypes.SKILL_JOURNEY);
      if (response?.status !== 200) throw Error("Error in fetching AI chats");

      const chats = response?.data?.data?.chats;
      if (!chats || chats.length === 0) return;

      const xpDetails = await fetchAllXPData();

      const updatedChats = chats.map((chat) => {
        const topic = chat.topic.replaceAll("_", " ");
        const xpDetailsOfTopic = xpDetails !== null ? xpDetails.find((xp) => xp.topic === topic) : null;
        if (xpDetailsOfTopic) {
          return {
            ...chat,
            topic: topic,
            totalXP: xpDetailsOfTopic.totalXP,
            level: xpDetailsOfTopic.level,
            xpToReachNextLevel: xpDetailsOfTopic.xpToReachNextLevel,
            xpInLevel: xpDetailsOfTopic.xpInLevel,
            questionCount: xpDetailsOfTopic.questionCount,
          };
        } else {
          return {
            ...chat,
            topic: topic,
            totalXP: 0,
            level: 1,
            xpToReachNextLevel: 100,
            xpInLevel: 0,
            questionCount: 0,
          };
        }
      });
      // console.log("Updated Chats: ", updatedChats.sort((a, b) => new Date(b.lastAccessedAt) - new Date(a.lastAccessedAt)), chats);
      setChats([...updatedChats].sort((a, b) => new Date(b.lastAccessedAt) - new Date(a.lastAccessedAt)));
      updateChartData(
        updatedChats.sort((a, b) => a.topic.localeCompare(b.topic))
      );
    } catch (error) {
      console.error("Error in (fetchAllChats): ", error);
    } finally {
      setSidePanelLoader(false);
    }
  };

  const handleDeleteChat = async (id) => {
    try {
      setShowLoader(true);
      if (!id) return;
      const response = await deleteAIChatSession(id);
      if (response?.status !== 200) throw Error("Error in deleting AI chat");

      const deletedChat = response?.data?.data?.aiChat;
      if (!deletedChat) throw Error("No chat session found");

      showToast("Journey deleted successfully", "success");
      const updatedChats = chats.filter((chat) => chat.id !== deletedChat.id);
      setChats(updatedChats);

      setData((prev) => {
        const updatedData = { ...prev };
        const index = updatedData.labels.indexOf(
          deletedChat.topic.replaceAll("_", " ")
        );
        if (index !== -1) {
          updatedData.labels.splice(index, 1);
          updatedData.datasets[0].data.splice(index, 1);
        }
        return updatedData;
      });

      if (aiChatId === deletedChat.id) {
        resetAll();
        navigate("/ai-skill-journey");
        return;
      }
    } catch (error) {
      console.error("Error in (handleDeleteChat): ", error);
      showToast("Error in deleting chat", "error");
    } finally {
      setShowLoader(false);
    }
  };

  const toggleSidePanel = () => {
    setSidePanel(!sidePanel);
  };

  useEffect(() => {
    const init = async () => {
      await fetchAllChats();
    };
    init();
  }, []);

  useEffect(() => {
    if (profile.userSubInterests) {
      setSidePanelLoader(false);
    }
  }, [profile.userSubInterests]);

  return (
    <div className={`${styles.side_panel} ${!sidePanel && styles.close}`}>
      <div
        className={`${styles.collapse_btn} ${!sidePanel && styles.close}`}
        onClick={toggleSidePanel}
      >
        <ArrowLeft className={styles.icon} />
      </div>

      <div className={`${styles.header} ${!sidePanel && styles.close}`}>
        <p className={styles.title}>Your Progress</p>
        <button
          className={styles.btn}
          onClick={() => setOpenConfigurationModal(true)}
        >
          <AddOutlined style={{ fontSize: "0.8rem" }} />
          <span>New Learning Journey</span>
        </button>
      </div>

      <div className={`${styles.body} ${!sidePanel && styles.close}`}>
        <div className={styles.divider} />
        <div className={styles.header}>Learning Stats</div>

        {sidePanelLoader ? (
          <Loading loadingPrimary="" loadingSecondary="loading..." />
        ) : (
          <div className={styles.chat_list}>
            {chats?.length > 0 ? (
              chats.map((chat) => {
                const id = chat.id;
                const isSelected = id === aiChatId;
                return (
                  <div
                    className={`${styles.chat_item} ${
                      isSelected && styles.active
                    }`}
                    key={id}
                    onClick={() => {
                      if (isSelected) return;
                      setLatestQuestionIndex(0);
                      navigate(`/ai-skill-journey/${id}`);
                      // getChatData(id);
                      if (window.innerWidth <= 800) {
                        setTimeout(() => {
                          setSidePanel(false);
                        }, 500);
                      }
                    }}
                  >
                    <div className={styles.header}>
                      <div className={`${styles.content}`}>
                        <p className={styles.level}>{chat.level}</p>
                        <p className={styles.topic} title={chat.topic}>
                          {chat.topic}
                        </p>
                      </div>
                      <div
                        className={styles.actions}
                        title="Delete"
                        onClick={async (e) => {
                          e.stopPropagation();
                          await handleDeleteChat(chat.id);
                        }}
                      >
                        <DeleteOutline className={styles.delete} />
                      </div>
                    </div>

                    <div className={styles.content}>
                      <div className={styles.config}>
                        <p>Grade: {chat?.config?.grade || "-"}</p>
                        <p>
                          Language:
                          {" " + chat?.config?.language?.toUpperCase() || "-"}
                        </p>
                      </div>

                      <div className={styles.xp_progress}>
                        {`${chat.totalXP} / ${chat.xpToReachNextLevel} XP`}
                      </div>
                    </div>

                    <div className={styles.chat_item_progress_bar}>
                      <div
                        className={styles.chat_item_progress_bar_fill}
                        style={{
                          width: `${chat.xpInLevel}%`,
                        }}
                      />
                      {/* <div
                            className="xp-label"
                            style={{
                              justifyContent: "center",
                              alignItems: "center",
                              width: "60px",
                              minWidth: "max-content",
                              height: "30px",
                              fontSize: "0.8rem",
                              position: "absolute",
                              left: `${
                                chat.xpInLevel > 0 ? `${chat.xpInLevel}%` : "0%"
                              }`,
                              top: "150%",
                              transform: `translateX(${
                                chat.xpInLevel > 0 ? `-50%` : "0%"
                              })`,
                              color: "#ffffff",
                              background: "#04a5a6",
                              clipPath:
                                "polygon(0% 30%,2% 24%,5% 22%,10% 20%,35% 20%,40% 15%,48% 1%,50% 0%,52% 1%,60% 15%,65% 20%,90% 20%,95% 22%,98% 24%,100% 30%,100% 90%,98% 95%,95% 98%,90% 100%,10% 100%,5% 98%,2% 95%,0% 90%)",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "end",
                                width: "100%",
                                height: "100%",
                                paddingBottom: "10%",
                                fontWeight: "600",
                              }}
                            >
                              {chat.xpInLevel} xp
                            </div>
                          </div> */}
                    </div>
                  </div>
                );
              })
            ) : (
              <p className={styles.no_progress}>
                No progress data available yet
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
